import styled from 'styled-components'
import { spacing, breakpoint } from '../theme'

export const TwoColumnContent = styled.div`
   display: grid;
   grid-gap: ${spacing.sm};
   grid-template-columns: 1fr;

   @media screen and (min-width: ${breakpoint.s}) {
      grid-gap: ${spacing.m};
      grid-template-columns: 1fr 1fr;
   }
`
